import { type } from "../../types/index";
import olvidoService from "../../services/olvido.contrasenia.service";

export const envionContraseniaTemporal = (email) => (dispatch) => {

    dispatch({type: type.clearMessage});
    dispatch({type: type.setLoading});

    return olvidoService.changePasswordRequest(email).then(
        (data) => {
            dispatch({type: type.setLoading});
            if(data === "ERROR_SERVICIO") {

                dispatch({
                    type: type.setError,
                    payload: {
                        tipoError: data.Codigo,
                        mensajeError: "Hay un problemas con el servicio intente mas tarde"
                    }
                });

            } else {
                console.log(1111);
                dispatch({
                    type: type.olvidoEnvioContraseniaTem,
                    payload: {
                        paso: 2,
                        email: email
                    }
                });
            }
            
            dispatch({
                type: type.textMessage,
                payload: data,
            });
            return Promise.resolve(data);
        },
        (error) => {
            const message = (error.response && error.response.data && error.response.data.message) ||
            error.message || error.toString();
            dispatch({type: type.setLoading});
            dispatch({
                type: type.olvidoEnvioContraseniaTemFail
            });
            dispatch({
                type: type.textMessage,
                payload: message
            });
            dispatch({
                type: type.setError,
                payload: {
                    tipoError: 0,
                    mensajeError: message
                }
            });
            return Promise.reject(error);
        }
    )
}

export const actualizacionContrasenia = (email, contraseniaTemporal, nuevaContrasenia, confirmarContrasenia) => (dispatch) => {
    
    dispatch({type: type.clearMessage});
    dispatch({type: type.setLoading});

    return olvidoService.changePassword(email, contraseniaTemporal, nuevaContrasenia, confirmarContrasenia).then(
        (data) => {
            dispatch({type: type.setLoading});
           // console.log(data);
            if(data === "ERROR_SERVICIO") {

                dispatch({
                    type: type.setError,
                    payload: {
                        tipoError: data.Codigo,
                        mensajeError: "Hay un problemas con el servicio intente mas tarde"
                    }
                });

            } else {
                dispatch({
                    type: type.olvidoActContrasenia,
                    payload: {
                        paso: 2
                    }
                });
            }
            
            dispatch({
                type: type.textMessage,
                payload: data,
            });
            return Promise.resolve(data);
        },
        (error) => {
            const message = (error.response && error.response.data && error.response.data.message) ||
            error.message || error.toString();
            dispatch({type: type.setLoading});

            dispatch({
                type: type.textMessage,
                payload: message
            });
            dispatch({
                type: type.setError,
                payload: {
                    tipoError: 0,
                    mensajeError: message
                }
            });
            return Promise.reject(error);
        }
    )

}

export const resetOlvido = () => (dispatch) => {
    dispatch({type: type.clearMessage});
    dispatch({
        type: type.olvidoActContrasenia,
        payload: {
            paso: 1,
            email: ""
        }
    });
}